import { combineReducers } from "redux";
import appConfig from "./appConfigReducer";
import apps from "./appsReducer";
import auth from "./authReducer";
import chat from "./chatReducer";
import controlPanel from "./controlPanelReducer";
import cultures from "./culturesReducer";
import experiences from "./experiencesReducer";
import integrations from "./integrationsReducer";
import modules from "./modulesReducer";
import notifications from "./notificationsReducer";
import oauth from "./oauthReducer";
import pages from "./pagesReducer";
import posts from "./postsReducer";
import responsive from "./responsiveReducer";
import sessions from "./sessionsReducer";
import themes from "./themesReducer";
import topics from "./topicsReducer";
import user from "./userReducer";
import validation from "./validationReducer";
import { StateType } from "typesafe-actions";

const rootReducer = combineReducers({
	appConfig,
	apps,
	auth,
	chat,
	controlPanel,
	cultures,
	experiences,
	integrations,
	modules,
	notifications,
	oauth,
	pages,
	posts,
	responsive,
	sessions,
	themes,
	topics,
	user,
	validation,
});

export type RootState = StateType<ReturnType<typeof rootReducer>>;

export interface TypedUseSelectorHook {
	<TSelected>(
		selector: (state: RootState) => TSelected,
		equalityFn?: (left: TSelected, right: TSelected) => boolean
	): TSelected;
}

export default rootReducer;
